import React, { type FC } from "react";

export type PageProps = {
  children?: React.ReactNode;
  title?: string;
  description?: string;
  showHeader?: boolean;
};

export const Page: FC<PageProps> = ({
  children,
  title,
  description,
  showHeader = true,
}) => {
  return (
    <div className="flex flex-col flex-1 h-full w-full overflow-y-scroll pt-8">
      <div className="flex flex-1 flex-col w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
        <div className="flex flex-col flex-1 px-4 sm:px-6 lg:px-8">
          {showHeader && (
            <div className="flex-grow-1">
              <div className="flex-grow-0 sm:flex flex-col sm:items-start">
                <h1 className="text-base font-semibold leading-6 text-gray-900">
                  {title}
                </h1>
                <p className="mt-2 text-sm text-gray-700">{description}</p>
              </div>
              <div className="mt-4 sm:ml-16 sm:mt-0"></div>
            </div>
          )}
          <div className="flex flex-col flex-grow-1  h-full">{children}</div>
        </div>
      </div>
    </div>
  );
};
